module.exports = __webpack_public_path__ + "officialStatic/img/product-tdzj.d787a8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/product-tdzj.png
// module id = JUl8
// module chunks = 0